import { useNavigate as useRouterNavigate } from 'react-router-dom';

// This utility helps handle navigation outside of React components
let navigator = null;

// This hook should be used in components to get the navigate function
export function useNavigate() {
	return useRouterNavigate();
}

// This function can be used outside of React components
export const navigate = (to, options) => {
	if (navigator) {
		navigator(to, options);
	} else {
		window.location.href = to;
	}
};

export const setNavigator = (nav) => {
	navigator = nav;
};
